if (!customElements.get('oddit-subscription-reviews')) {
  customElements.define(
    'oddit-subscription-reviews',
    class OdditSubscriptionReviews extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sliderEl = this.querySelector('.swiper');
        this.autoplayDelay = this.dataset.autoplay ? parseInt(this.dataset.autoplay, 10) : 0;
        this.sliderInstance = false;

        if (!this.sliderEl || this.querySelectorAll('.swiper-slide').length < 2) return;

        this.initSlider();

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId !== this.dataset.sectionId) return;
            const slide = e.target.closest('.swiper-slide');
            const index = Number(slide?.dataset.index);
            if (!Number.isNaN(index) && this.sliderInstance?.slider) {
              this.sliderInstance.slider.slideToLoop(index);
            }
          });
        }
      }

      disconnectedCallback() {
        this.destroySlider();
      }

      initSlider() {
        this.destroySlider();

        const updatePaginationA11y = (swiper) => {
          const bullets = swiper.pagination?.bullets || [];
          bullets.forEach((bullet, index) => {
            const isActive = index === swiper.realIndex;
            bullet.setAttribute('aria-current', isActive ? 'true' : 'false');
            bullet.setAttribute('aria-label', `Go to review ${index + 1} of ${bullets.length}`);
          });
        };

        const sliderOptions = {
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 24,
          loop: true,
          threshold: 2,
          grabCursor: true,
          watchSlidesProgress: true,
          navigation: {
            nextEl: this.querySelector('.oddit-sub-reviews__arrow--next'),
            prevEl: this.querySelector('.oddit-sub-reviews__arrow--prev'),
          },
          pagination: {
            el: this.querySelector('.oddit-sub-reviews__pagination'),
            type: 'bullets',
            clickable: true,
            bulletClass: 'oddit-sub-reviews__dot',
            bulletActiveClass: 'oddit-sub-reviews__dot--active',
            renderBullet(index, className) {
              return `
                <button
                  type="button"
                  class="${className}"
                  aria-label="Go to review ${index + 1}"
                  data-review-dot="${index}"
                >
                  <span class="visually-hidden">Review ${index + 1}</span>
                </button>
              `;
            },
          },
          breakpoints: {
            768: {
              slidesPerView: 'auto',
              spaceBetween: 60,
            },
          },
          on: {
            init(swiper) {
              updatePaginationA11y(swiper);
            },
            slideChange(swiper) {
              updatePaginationA11y(swiper);
            },
            paginationUpdate(swiper) {
              updatePaginationA11y(swiper);
            },
          },
        };

        if (this.autoplayDelay > 0) {
          sliderOptions.autoplay = {
            delay: this.autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          };
        }

        const modules = [];
        if (this.autoplayDelay > 0) modules.push(FoxTheme.Swiper.Autoplay);

        this.sliderInstance = new FoxTheme.Carousel(this.sliderEl, sliderOptions, modules);
        this.sliderInstance.init();
      }

      destroySlider() {
        if (typeof this.sliderInstance !== 'object' || !this.sliderInstance.slider) return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  );
}
